module.exports = __webpack_public_path__ + "static/media/effect-bullying.142e20e1.jpg";